import {hasLessThan} from "../../utils/strings";
import {MediaMimeTypes, CategoryType} from "../../services/file/file";
export function ExhibitionForm() {

  // metadata about files
  this.mediaOptions = [
      MediaOption(1, "English"),
  ];
  this.fileOptions = [
      FileOption("Title", "title_page_image"),
      FileOption("Choose language", "choose_language_page_image"),
      FileOption("Language", "language_page_image"),
      FileOption("Listen", "listen_page_image"),
      FileOption("Player", "player_page_image"),
  ]

  this.productCode = "";
  this.clientCode = "";

  // store files by pair key => value
  this.mediaFiles = {};
  this.imageFiles = {};
}

ExhibitionForm.prototype.validateFields = validateFields;
ExhibitionForm.prototype.canAddNewMediaOption = canAddNewMediaOption;
ExhibitionForm.prototype.removeMediaOption = removeMediaOption;
ExhibitionForm.prototype.addNewMediaOption = addNewMediaOption;
ExhibitionForm.prototype.updateMediaOption = updateMediaOption;

function validateFields() {
    let error = {};
    if (!this.clientCode) {
        error.localizedKey =  "client_code_is_empty"
        return error
    }
    const hasEmptyMediaFileTitle = this.mediaOptions.some(mediaOption => {
      return !mediaOption.titleFile.length
    });
    const uniqueMediaFileNames = new Set(this.mediaOptions.map(mediaOption => mediaOption.titleFile));
    if (!this.productCode) {
        error.localizedKey = "product_code_is_empty"
        return error
    }
    const hasAllImageFiles = this.fileOptions.every(fileOption => {
        return this.imageFiles.hasOwnProperty(fileOption.id)
    });
    const isImageFiles = Object.values(this.imageFiles).every(imageFile => {
        const categoryType = MediaMimeTypes.getMediaTypeCategoryFromFile(imageFile);
        return categoryType === CategoryType.IMAGE;
    });
    const isMediaFiles = Object.values(this.mediaFiles).every(mediaFile => {
        const categoryType = MediaMimeTypes.getMediaTypeCategoryFromFile(mediaFile);
        return categoryType === CategoryType.VIDEO || categoryType === CategoryType.AUDIO || categoryType === CategoryType.IMAGE;
    });
    const hasAllMediaFiles = this.mediaOptions.every(mediaOption => {
        return this.mediaFiles.hasOwnProperty(mediaOption.id)
    });
    const hasEnoughCharsInMediaFileNames = this.mediaOptions.every(mediaOption => {
      return hasLessThan(mediaOption.titleFile, 21);
    });
    const hasUniqueMediaFileNames = uniqueMediaFileNames.size === this.mediaOptions.length;
    if (!hasAllImageFiles) {
        error.localizedKey = "image_files_is_missing";
        return error;
    }
    if (!hasAllMediaFiles) {
        error.localizedKey = "audio_files_is_missing";
        return error;
    }
    if (hasEmptyMediaFileTitle) {
      error.localizedKey = "audio_files_has_title_missing";
      return error;
    }
    if (!hasUniqueMediaFileNames) {
        error.localizedKey = "non_unique_audio_files";
        return error;
    }
    if (!hasEnoughCharsInMediaFileNames) {
        error.localizedKey = "file_name_too_long_error";
        return error;
    }
    if (!isImageFiles) {
        error.localizedKey = "image_file_require";
        return error;
    }
    if (!isMediaFiles) {
        error.localizedKey = "media_file_require";
        return error;
    }

    return null
}

function updateMediaOption(id, titleFile, originName) {
  const targetIndex = this.mediaOptions.findIndex(mediaOption => {
    return mediaOption.id === id;
  });
  this.mediaOptions[targetIndex].originName = originName;
  this.mediaOptions[targetIndex].titleFile = titleFile;
  this.mediaOptions[targetIndex].errLocalizedKey = null;
  if (!hasLessThan(titleFile, 21)) {
    this.mediaOptions[targetIndex].errLocalizedKey = "file_name_too_long_error";
  }
}

function canAddNewMediaOption() {
  return this.mediaOptions.length < 4;
}

function addNewMediaOption() {
  let greatestID = Math.max(...this.mediaOptions.map(mediaOption => mediaOption.id)) + 1;
  let addNewMediaOption = MediaOption(greatestID, "");
  this.mediaOptions.push(addNewMediaOption);
}

function removeMediaOption(id) {
    const targetIndex = this.mediaOptions.findIndex(mediaOption => {
      return mediaOption.id === id
    });
    this.mediaOptions.splice(targetIndex, 1)
}

function FileOption(id, localizedKey) {
    return {
        id: id,
        localizedKey: localizedKey,
        remoteErrorMessage: null,
    };
}

function MediaOption(id, titleFile) {
  return {
      id: id,
      titleFile: titleFile,
      originName: null,
      errLocalizedKey: null,
      remoteErrorMessage: null,
  };
}